import { usePasswordEditorState } from 'hooks/usePasswordEditorState';

export const usePasswordFormBusy = (): boolean => {
  const { submited, submitDidSucceed } = usePasswordEditorState();

  return submited && !submitDidSucceed;
};
